/* App Settings (Default Links) service.
 * Mirrors services/industry.js — class with static methods and Promise-wrapped
 * Request.send calls that always resolve (never throw) with
 * { success, data | errors } payloads. */

import Request from './request';

export default class AppSettingsService {
  static async get() {
    return new Promise((resolve) => {
      Request.send({ method: 'GET', path: 'admin/app-settings' })
        .then((result = {}) => {
          if (result.success && result.data) {
            return resolve({ success: true, data: result.data });
          }
          return resolve(result);
        })
        .catch((error) => {
          console.error('AppSettings get error:', error);
          return resolve({
            success: false,
            errors: [{ message: error.message || 'Failed to fetch settings' }]
          });
        });
    });
  }

  static async update(data = {}) {
    const payload = {};
    if (data.googleInstructionLink !== undefined) {
      payload.googleInstructionLink = String(data.googleInstructionLink || '').trim();
    }
    if (data.yelpInstructionLink !== undefined) {
      payload.yelpInstructionLink = String(data.yelpInstructionLink || '').trim();
    }
    if (data.supportContactEmail !== undefined) {
      payload.supportContactEmail = String(data.supportContactEmail || '').trim();
    }

    return new Promise((resolve) => {
      Request.send({ method: 'PATCH', path: 'admin/app-settings', data: payload })
        .then((result = {}) => {
          if (result.success && result.data) {
            return resolve({ success: true, data: result.data });
          }
          return resolve(result);
        })
        .catch((error) => {
          console.error('AppSettings update error:', error);
          return resolve({
            success: false,
            errors: [{ message: error.message || 'Failed to update settings' }]
          });
        });
    });
  }
}
